// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.encargado-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.encargado-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--radius-0);
  cursor: pointer;
  transition: background 0.1s;
}

.encargado-row:hover {
  background: var(--bg-alt);
}

.encargado-row--selected {
  background: var(--accent-soft);
}

.encargado-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  font-size: var(--fs-sm);
  font-weight: 600;
  flex-shrink: 0;
}

.encargado-name {
  font-size: var(--fs-note);
  color: var(--text, #111);
}
`, "",{"version":3,"sources":["webpack://./src/pages/causas/AsignarEncargadoModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":[".encargado-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.encargado-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: var(--radius-0);\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.encargado-row:hover {\n  background: var(--bg-alt);\n}\n\n.encargado-row--selected {\n  background: var(--accent-soft);\n}\n\n.encargado-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--accent);\n  color: var(--accent-ink);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.encargado-name {\n  font-size: var(--fs-note);\n  color: var(--text, #111);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
